// lib/cookies.js
export function readJsonCookie(name) {
    try {
        const raw = getCookie(name);
        if (!raw) return null;
        return JSON.parse(decodeURIComponent(raw));
    } catch {
        return null;
    }
}

export function writeJsonCookie(name, value, { days = 365 } = {}) {
    const maxAge = days * 24 * 60 * 60;
    const json = encodeURIComponent(JSON.stringify(value));
    const secure =
        typeof location !== "undefined" && location.protocol === "https:"
            ? "; Secure"
            : "";
    document.cookie = `${name}=${json}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

export function getCookie(name) {
    if (typeof document === "undefined") return "";
    return (
        document.cookie
            .split("; ")
            .find((c) => c.startsWith(`${name}=`))
            ?.split("=")[1] || ""
    );
}
